export enum Groups {
  APP = 'app',
  DIGITAL_COURSE = 'digitalCourse',
  EVENTS = 'events',
  LIBRARY = 'library',
  DASHBOARD = 'dashboard',
  TMATT = 'tmatt',
}

export enum DigitalCourse {
  VIEW = 'view',
  ENROLL = 'enroll',
  ADJUST_POSITION = 'adjustPosition',
  REINSTATE = 'reinstate',
}

export enum Events {
  LIST_ALL_AVAILABILITIES = 'listAllAvailabilities',
  LIST_AVAILABILITIES = 'listAvailabilities',
  VIEW_ALL_AVAILABILITIES = 'viewAllAvailabilities',
  VIEW_AVAILABILITIES = 'viewAvailabilities',
  CREATE_ALL_INTRO_AVAILABILITIES = 'createAllIntroAvailabilities',
  CREATE_ALL_IN_PERSON_COURSE_AVAILABILITIES = 'createAllInPersonCourseAvailabilities',
  CREATE_ALL_DC_COURSE_AVAILABILITIES = 'createAllDCCourseAvailabilities',
  CREATE_INTRO_AVAILABILITIES = 'createIntroAvailabilities',
  CREATE_IN_PERSON_COURSE_AVAILABILITIES = 'createInPersonCourseAvailabilities',
  CREATE_DC_COURSE_AVAILABILITIES = 'createDCCourseAvailabilities',
  CREATE_TEST_DC_COURSE_AVAILABILITIES = 'createTestDCCourseAvailabilities',
  UPDATE_ALL_AVAILABILITIES = 'updateAllAvailabilities',
  UPDATE_AVAILABILITIES = 'updateAvailabilities',
  DELETE_ALL_AVAILABILITIES = 'deleteAllAvailabilities',
  DELETE_AVAILABILITIES = 'deleteAvailabilities',

  LIST_ALL_EXCEPTIONS = 'listAllExceptions',
  LIST_EXCEPTIONS = 'listExceptions',
  VIEW_ALL_EXCEPTIONS = 'viewAllExceptions',
  VIEW_EXCEPTIONS = 'viewExceptions',
  CREATE_ALL_EXCEPTIONS = 'createAllExceptions',
  CREATE_EXCEPTIONS = 'createExceptions',
  UPDATE_ALL_EXCEPTIONS = 'updateAllExceptions',
  UPDATE_EXCEPTIONS = 'updateExceptions',
  DELETE_ALL_EXCEPTIONS = 'deleteAllExceptions',
  DELETE_EXCEPTIONS = 'deleteExceptions',

  LIST_ALL_APPOINTMENTS = 'listAllAppointments',
  LIST_APPOINTMENTS = 'listAppointments',
  VIEW_ALL_APPOINTMENTS = 'viewAllAppointments',
  VIEW_APPOINTMENTS = 'viewAppointments',
  CREATE_ALL_APPOINTMENTS = 'createAllAppointments',
  CREATE_APPOINTMENTS = 'createAppointments',
  UPDATE_ALL_APPOINTMENTS = 'updateAllAppointments',
  UPDATE_APPOINTMENTS = 'updateAppointments',
  DELETE_ALL_APPOINTMENTS = 'deleteAllAppointments',
  DELETE_APPOINTMENTS = 'deleteAppointments',
}

export enum Dashboard {
  LIST_ALL_USERS = 'listAllUsers',
  LIST_USERS = 'listUsers',
  VIEW_ALL_USERS = 'viewAllUsers',
  VIEW_USERS = 'viewUsers',
  CREATE_USERS = 'createUsers',
  CREATE_TEACHERS = 'createTeachers',
  CREATE_TEST_USERS = 'createTestUsers',
  UPDATE_ALL_USERS = 'updateAllUsers',
  UPDATE_USERS = 'updateTestUsers',
  DELETE_USERS = 'deleteUsers',
  DEACTIVATE_USERS = 'deactivateUsers',
  CLEAR_DEVICES = 'clearDevices',
  SEND_DOWNLOAD_INSTRUCTION = 'sendDownloadInstructions',
  VIEW_HELP_CENTER = 'viewHelpCenter',
  NO_DATE_OF_INSTRUCTION_RESTRICTION = 'noDateOfInstructionRestriction',
}

export enum TMATT {
  ENROLL = 'enroll',
}
